export const CATECHISM_ITEMS = [
  {
    id: 1,
    question: "How do we know that God exists?",
    answer:
      "We know God exists through understanding the Bible and observing the order and design of the world He created.",
  },
  {
    id: 2,
    question: "What do we believe about the Trinity?",
    answer:
      "We believe in one God revealed as God the Father, God the Son, and God the Holy Spirit — the Godhead in three Persons.",
  },
  {
    id: 3,
    question: "What is the nature of man?",
    answer: "Man is God's creation, made with the ability to think, choose, and relate to his Creator.",
  },
  {
    id: 4,
    question: "How did man fall into sin?",
    answer:
      "Man fell into slavery and hardship through sin, departing from God's command and losing fellowship with Him.",
  },
  {
    id: 5,
    question: "What is the means of salvation?",
    answer: "Salvation is by grace through faith in Jesus Christ, not by human merit or works.",
  },
  {
    id: 6,
    question: "Who is Jesus Christ?",
    answer: "Jesus Christ is the Son of God and the Saviour of the world.",
  },
  {
    id: 7,
    question: "Who is the Holy Spirit?",
    answer: "The Holy Spirit is the third Person of the Trinity, equal with the Father and the Son.",
  },
  {
    id: 8,
    question: "What is the work of the Holy Spirit?",
    answer:
      "The Holy Spirit guides, teaches, comforts, convicts of sin, sanctifies, and empowers believers for holy living and service.",
  },
  {
    id: 9,
    question: "What is sin?",
    answer: "Sin is the violation of God's commandment — transgression of His holy law.",
  },
  {
    id: 10,
    question: "What is the wages of sin?",
    answer: "The wages of sin is death — spiritual separation from God and eternal judgment.",
  },
  {
    id: 11,
    question: "How can we be saved from sin?",
    answer: "Salvation from sin is only through Jesus Christ, who died and rose again for us.",
  },
  {
    id: 12,
    question: "What is heaven?",
    answer: "Heaven is the place and state of blessing — the eternal habitation of God and His redeemed people.",
  },
  {
    id: 13,
    question: "What is hell?",
    answer:
      "Hell is the place of suffering — the habitation of the devil, sin, and eternal death for the unredeemed.",
  },
  {
    id: 14,
    question: "What is faith?",
    answer:
      "Faith is the substance of things hoped for, the evidence of things not seen (Hebrews 11:1).",
  },
  {
    id: 15,
    question: "What is the Bible?",
    answer: "The Bible is the holy Word of God — inspired, infallible, and our final authority for faith and life.",
  },
  {
    id: 16,
    question: "What did Jesus say about children?",
    answer:
      "Suffer little children to come unto Me… for of such is the kingdom of heaven (Matthew 19:14).",
  },
  {
    id: 17,
    question: "Can we fully understand God?",
    answer:
      "There are things about God we cannot fully comprehend; we humbly trust what He has revealed in Scripture.",
  },
  {
    id: 18,
    question: "How should a Christian treat others?",
    answer:
      "See God in others, pray for understanding of His Word, and walk humbly in love and holiness.",
  },
  {
    id: 19,
    question: "What do we believe about the resurrection?",
    answer:
      "We believe in the resurrection of the dead — to eternal life for the saved and eternal damnation for the lost, according to God's promise and power.",
  },
  {
    id: 20,
    question: "Who fell into sin first?",
    answer:
      "Eve was the first to fall into sin after being deceived by the serpent; Adam also transgressed, and sin entered the human race.",
  },
  {
    id: 21,
    question: "What must we do to receive forgiveness?",
    answer:
      "Repent, confess our sins to God, believe in Jesus Christ, and forsake sin with a willing heart.",
  },
  {
    id: 22,
    question: "What lesson do we learn from Peter's denial?",
    answer:
      "Even when we fail, God restores the repentant heart. Failure is not final when we return to Christ.",
  },
  {
    id: 23,
    question: "Recite the truth of your faith.",
    answer:
      "I believe in God, I believe Jesus His only begotten Son, who was conceived of the Holy Ghost, born of the virgin Mary, suffered under Pontius Pilate, was crucified, died and was buried, rose again on the third day, ascended to heaven, and sits at the right hand of God the Father Almighty.",
  },
  {
    id: 24,
    question: "How did Jesus teach His disciples to pray?",
    answer:
      "Our Father in heaven, hallowed be Thy name. Thy kingdom come. Thy will be done on earth as it is in heaven. Give us this day our daily bread. Forgive us our debts as we forgive our debtors. Lead us not into temptation, but deliver us from evil. For Thine is the kingdom, and the power, and the glory, forever. Amen.",
  },
  {
    id: 25,
    question: "Name the twelve tribes of Israel.",
    answer:
      "Reuben, Simeon, Levi, Judah, Dan, Naphtali, Gad, Asher, Issachar, Zebulun, Joseph, and Benjamin.",
  },
  {
    id: 26,
    question: "Why is medicine often bitter?",
    answer:
      "The word of God may seem bitter to the carnal mind, but it heals the soul as medicine heals the body.",
  },
  {
    id: 27,
    question: "What does rain from the sea teach us?",
    answer:
      "As clouds draw from the sea and return rain, ministers receive from God and pass knowledge to others.",
  },
  {
    id: 28,
    question: "What does the rainbow signify?",
    answer: "The rainbow is the covenant sign of God's grace and faithfulness to His people.",
  },
];

export const OLD_TESTAMENT_BOOKS = [
  "Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy",
  "Joshua", "Judges", "Ruth", "1 Samuel", "2 Samuel",
  "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles", "Ezra",
  "Nehemiah", "Esther", "Job", "Psalms", "Proverbs",
  "Ecclesiastes", "Song of Solomon", "Isaiah", "Jeremiah", "Lamentations",
  "Ezekiel", "Daniel", "Hosea", "Joel", "Amos",
  "Obadiah", "Jonah", "Micah", "Nahum", "Habakkuk",
  "Zephaniah", "Haggai", "Zechariah", "Malachi",
];

export const NEW_TESTAMENT_BOOKS = [
  "Matthew", "Mark", "Luke", "John", "Acts",
  "Romans", "1 Corinthians", "2 Corinthians", "Galatians", "Ephesians",
  "Philippians", "Colossians", "1 Thessalonians", "2 Thessalonians", "1 Timothy",
  "2 Timothy", "Titus", "Philemon", "Hebrews", "James",
  "1 Peter", "2 Peter", "1 John", "2 John", "3 John",
  "Jude", "Revelation",
];
